import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "./styles.scss";
import PostDetailLayoutPanel, {
  PostDetailLayoutPanelProps,
} from "./postDetail/layoutPanel";

interface Section {
  id: string;
  title: string;
  helpText: string;
  component: React.ReactNode;
}

interface LeftSideBarProps {
  selectedSection?: Section;
  variables: Record<string, { value: any; setValue: (value: any) => void }>;
  charityId?: string;
  firebase?: any;
  onError?: (message: string) => void;
  postDetailLayout?: PostDetailLayoutPanelProps;
}

const LeftSidebar = ({
  selectedSection,
  variables,
  charityId,
  firebase,
  onError,
  postDetailLayout,
}: LeftSideBarProps) => {
  return (
    <div className={styles.sidebar}>
      <Card
        className={
          postDetailLayout
            ? `${styles.sidebarCard} ${styles.postDetailSidebarCard}`
            : styles.sidebarCard
        }
      >
        {postDetailLayout && (
          <CardBody className={`${styles.cardBody} ${styles.layoutPanelBody}`}>
            <PostDetailLayoutPanel {...postDetailLayout} />
          </CardBody>
        )}
        <CardHeader
          className={
            postDetailLayout
              ? `${styles.cardHeader} ${styles.postDetailSectionHeader}`
              : styles.cardHeader
          }
        >
          <h3 className={styles.sectionTitle}>
            {selectedSection?.title || "Select a section to start"}
          </h3>
        </CardHeader>

        {selectedSection?.component &&
          React.cloneElement(
            selectedSection.component as React.ReactElement<any>,
            { variables, charityId, firebase, onError }
          )}
      </Card>
    </div>
  );
};

export default withStyles(styles)(LeftSidebar);
